/**
 * Hidden elements that carry token colours for the 3D scenes to read. A scene cannot see a CSS
 * variable, but it can read the computed colour of an element that uses one, so each tone here is
 * a span coloured by its token. The ink tones sit in the `paper` theme, which is how the label on a
 * physical pouch is printed wherever the pouch appears.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/product.stylex";
import { product } from "@lattice/tokens/product.stylex";
import { paper } from "@lattice/tokens/themes";
const styles = {
  film: {
    kMwMTN: "x8oea33",
    $$css: true
  },
  vitaminD: {
    kMwMTN: "xxu618d",
    $$css: true
  },
  magnesium: {
    kMwMTN: "x1vck6zu",
    $$css: true
  },
  capsule: {
    kMwMTN: "xgahtts",
    $$css: true
  },
  folate: {
    kMwMTN: "xxxav6",
    $$css: true
  },
  b12: {
    kMwMTN: "x1esssmk",
    $$css: true
  },
  creatine: {
    kMwMTN: "x11ay9kx",
    $$css: true
  },
  omega3: {
    kMwMTN: "x1cjyzzg",
    $$css: true
  },
  scoop: {
    kMwMTN: "xan7ty5",
    $$css: true
  },
  whey: {
    kMwMTN: "x1a8moe1",
    $$css: true
  },
  ink: {
    kMwMTN: "xzb3lse",
    $$css: true
  },
  dim: {
    kMwMTN: "x1jty25b",
    $$css: true
  },
  signal: {
    kMwMTN: "xgjxun8",
    $$css: true
  }
};
export type Tone = keyof typeof styles;
const TONES: readonly Tone[] = ["film", "vitaminD", "magnesium", "capsule", "folate", "b12", "creatine", "omega3", "scoop", "whey", "ink", "dim", "signal"];
export function Tones() {
  return <span hidden {...stylex.props(paper)}>
      {TONES.map(tone => <span key={tone} data-tone={tone} {...stylex.props(styles[tone])} />)}
    </span>;
}
export function toneElement(root: Element, tone: Tone): Element {
  return root.querySelector(`[data-tone="${tone}"]`) ?? root;
}

/** The tone's computed colour as a CSS string, for drawing on a 2D canvas. */
export function toneCss(root: Element, tone: Tone): string {
  return getComputedStyle(toneElement(root, tone)).color;
}